import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=486d9521&"
import script from "./BaseSection.vue?vue&type=script&lang=ts&"
export * from "./BaseSection.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports